import { toaster } from "baseui/toast";
import { LabelMedium, ParagraphMedium, ParagraphSmall, ParagraphXSmall } from "baseui/typography";
import { useEffect } from "react";
import { HttpStatusCodesToString } from "../../services/types";
import { Check } from "baseui/icon";
import { SnackbarElementProps, useSnackbar } from "baseui/snackbar";

function useReportMutationState(
  mutationResult: any,
  onSuccess?: () => void,
  successMessage: SnackbarElementProps = {
    message: "Successfully executed",
    startEnhancer: ({ size }) => <Check size={size} />,
  }) {

  const { enqueue } = useSnackbar();
  useEffect(() => {

    if (mutationResult.isError) {
      const err: any = mutationResult.error;
      const httpstatus = err.originalStatus ?? err.status;
      const errMsg = err?.data?.errorMessage ?? err?.data?.message ?? err?.data !== undefined ? JSON.stringify(err.data) : "";
      toaster.negative(
        <>
          <LabelMedium color='white'>Eror write value </LabelMedium>
          <ParagraphSmall color='white' margin={0}>{errMsg}</ParagraphSmall>
          <ParagraphXSmall color='white' margin={0}>{HttpStatusCodesToString(httpstatus)}</ParagraphXSmall>
        </>, {
        autoHideDuration: 7000, overrides: {
          Body: {
            style: ({ $theme }) => ({
              width: "auto"
            })
          },
        }
      })
    }

    if (mutationResult.isSuccess) {
      if (onSuccess)
        onSuccess();

      if ( successMessage )
        enqueue(successMessage)

    }
  }, [mutationResult]);
}

export default useReportMutationState;